import React from "react";
import styled from "styled-components";

import { Form, Text, VSpace } from "@examspark/common-ui";

import { NewActivityContext } from "../../../../classroom";

import LanguageSelect from "./LanguageSelect";
import NewActivityObjectives from "./NewActivityObjectives";
import NewActivityPassages from "./NewActivityPassages";
import NewActivityQuestionTypes from "./NewActivityQuestionTypes";
import SubjectGradeSelect from "./SubjectGradeSelect";

export const Count = styled.div`
  background-color: #006699;
  color: #fff;
  border-radius: 1rem;
  text-align: center;
  padding: 0.4rem 0.5rem;
  font-size: 1rem;
`;

const StyledForm = styled.div`
  margin: 0 auto;
  max-width: 80rem;
  display: flex;
  justify-content: center;

  h2 {
    margin: 0;
  }
`;
const StyledFormWidth = styled.div`
  margin: 0 auto;
  flex: 1;
`;
export const FormSection = styled.div``;
const Center = styled.div``;

const StyledTableHeaderTable = styled.div`
  padding: 1rem;
  display: flex;
  align-items: flex-end;
  border-bottom: solid 1px #ddd;
  color: #777;
  line-height: 1.3em;
`;

type StyledTableHeaderColumnProps = {
  textAlign?: "left" | "center" | "right";
  flex?: number;
};

const StyledTableHeaderColumn = styled.div<StyledTableHeaderColumnProps>`
  text-align: ${(props) => props.textAlign ?? "left"};
  flex: ${(props) => props.flex ?? 1};
`;

const StyledTableHeader = {
  Table: StyledTableHeaderTable,
  Column: StyledTableHeaderColumn,
};

export { StyledTableHeader };

/**
 * A guided wizard-like form used to build an exam. This component is used
 * inside of the ActivityEditor.
 */
const ExamBuilder = (props: { objectiveAuthorityId: string }) => {
  const [state] = React.useContext(NewActivityContext);
  const { objectiveAuthorityId } = props;

  return (
    <Center>
      <StyledForm>
        <StyledFormWidth>
          <VSpace size="3rem">
            <FormSection>
              <VSpace size="1rem">
                <Text.H2>Basic Information</Text.H2>
                <VSpace>
                  <SubjectGradeSelect
                    objectiveAuthorityId={objectiveAuthorityId}
                  />
                  <Form.Field label="Language">
                    <LanguageSelect />
                  </Form.Field>
                </VSpace>
              </VSpace>
            </FormSection>
            {state.language && (
              <FormSection>
                <NewActivityObjectives
                  objectiveAuthorityId={objectiveAuthorityId}
                />
              </FormSection>
            )}
            {state.sections && state.language && !!state.objectives.length && (
              <NewActivityPassages
                objectiveAuthorityId={objectiveAuthorityId}
              />
            )}
            {state.language && !!state.objectives.length && (
              <FormSection>
                <NewActivityQuestionTypes />
              </FormSection>
            )}
          </VSpace>
        </StyledFormWidth>
      </StyledForm>
    </Center>
  );
};

export default ExamBuilder;
